//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';

import warningIcon from '../../../../../assets/img/warningIcon.png';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {useFeatureSpec} from '../../../../../utils/component';

type Props = {|
  handleConfirm?: () => void,
  openModal?: boolean,
  showOnlyCreate?: boolean,
  handleCloseModal?: () => void,
  handleOnlyCreate?: () => void,
|};

const useStyles = makeStyles(theme => ({
  mediumText: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '36px',
    lineHeight: '40px',
    color: 'white',
    paddingRight: '8px',
    display: 'flex',
    margin: 'auto',
    alignItems: 'center',
  },
  titleModal: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#313135',
    textAlign: 'center',
  },
  bodyModal: {
    marginTop: theme.spacing(2),
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#55556D',
    textAlign: 'center',
  },
}));

export default function AlertActivePromotion(props: Props) {
  const {
    // handleConfirm,
    handleCloseModal,
    handleOnlyCreate,
    openModal,
    showOnlyCreate = false,
  } = props;
  const classes = useStyles();

  const promotionSpec = useFeatureSpec('STORE_PROMOTION');

  return (
    <CustomModal open={openModal} handleCloseModal={handleCloseModal}>
      <div style={{maxWidth: '340px', padding: '24px', textAlign: 'center'}}>
        <div className={classes.imageModal}>
          <img src={warningIcon} alt="Warn icon" />
        </div>
        <br />
        <div className={classes.titleModal}>
          {`Sólo puedes activar ${
            promotionSpec && promotionSpec.limit
              ? promotionSpec.limit === 1
                ? 'una promoción'
                : `${promotionSpec.limit} promociones`
              : 'una'
          } a la vez.`}
        </div>
        {showOnlyCreate && (
          <div className={classes.bodyModal}>
            Si decides crear promoción aparecerá como inactiva.
          </div>
        )}

        <div className={classes.bodyModal}>
          *Para habilitar esta promoción debes deshabilitar una actual.
        </div>
        {showOnlyCreate && (
          <div style={{marginTop: '24px'}}>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={handleOnlyCreate}
            >
              Solo crear promoción
            </CustomButton>
          </div>
        )}
      </div>
    </CustomModal>
  );
}

AlertActivePromotion.propTypes = {
  handleConfirm: PropTypes.func,
  handleOnlyCreate: PropTypes.func,
  showOnlyCreate: PropTypes.bool,
  openModal: PropTypes.bool,
  handleCloseModal: PropTypes.func,
};
